import { computed, ref, nextTick, createVNode, onMounted, onBeforeUnmount } from 'vue'
import { useStore } from 'vuex'
import EventBus from '@/utils/EventBus.js'
import { chatLogin, messageRecall } from '@/api/chat.js'
import moment from 'moment'
import Config from '@/config/index'
import { talkToPat, talkToDoctor } from '@/api/chat.js'
import { handleMsgRole } from '@/utils'
import getCurrentGroupInfo from '@/views/hooks/getCurrentGroupInfo'
import { Modal, message as Message } from 'ant-design-vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { renderTitle, renderName, handleImg } from '@/utils'
import { copyImage } from '@/views/WorkPlace/Container/chat/components/contenteditable/clipboard'
import getMoreMsg from '@/assets/img/chat/more.png'
import toTop from '@/assets/img/chat/moreMessage/top.png'
import toBottom from '@/assets/img/chat/moreMessage/down.png'

export default function useChatAction(
  messageMap,
  newMsgTipsMap,
  messageboxRefs,
  activeKey,
  privateId,
  doctorDaGroupId,
  imageViewerRef,
  imageViewerVisible,
  chatInfoGroupTabs,
  queryHistoryMessage,
  getConsultDetail
) {
  const store = useStore()
  //撤回消息对象
  const recallData = ref({})
  //系统消息对应文本
  const tipsMessageType = Object.keys(Config.TIPS_MESSAGE_TYPE) || []
  // 撤回操作点击实例
  const activePopoverMessageId = ref('')
  // 环信异常状态
  const imErrorVisible = ref(false)
  // loading 状态
  const isSpinning = ref(false)
  // 是否启用已读未读功能
  const isReadAckEnabled = computed(() => store.state.user.isOpenReadAck)
  // 消息撤回配置
  const imConfig = computed(() => store.state.user.imConfig || {})
  // 默认图
  const defaultImage =
    'data:image/png;base64,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'
  // 判断时间是否显示

  const getTimeVisible = (pre, cur) => {
    const preTime = pre.time
    const curTime = cur.time
    const showTime = curTime - preTime > 60000
    // 解决屏蔽的消息类型后面新消息不展示发送时间问题
    if (!showTime && Config.SHIELD_MSG.includes(pre.customEvent)) {
      return true
    } else {
      return showTime
    }
  }
  // 异常回调
  const handleImError = (message = {}) => {
    if (message.type === 16) {
      imErrorVisible.value = true
    }
  }
  // 重连操作
  const reconnect = () => {
    chatLogin(store.getters.chatId)
    isSpinning.value = true
  }
  // 通用滚动事件处理
  const handleScrollEvent = () => {
    messageboxRefs[activeKey.value]?.removeEventListener('scroll', handleScrollEvent)
    activePopoverMessageId.value = ''
  }
  // 通用右键处理逻辑
  const handleContextMenu = (item, isImage = false) => {
    if (!isImage && item.bySelf) {
      handleRecallableMessage(item)
    } else {
      attachScrollListener()
      activePopoverMessageId.value = item.mid
    }
  }
  // 消息撤回逻辑
  const handleRecallableMessage = item => {
    const recallTimeLimit = imConfig.value.messageRecallTime
    // 判断是否设置了无限制撤回
    const isUnlimitedRecall = recallTimeLimit === 0
    if (
      !isUnlimitedRecall &&
      (moment().valueOf() - item.time > recallTimeLimit || !imConfig.value.messageRecallSwitch)
    ) {
      return
    }
    attachScrollListener()
    activePopoverMessageId.value = item.mid
  }
  // 附加滚动事件监听器
  const attachScrollListener = () => {
    messageboxRefs[activeKey.value]?.addEventListener('scroll', handleScrollEvent)
  }
  //判断展示重新编辑按钮
  const renderEdit = (item = {}) => {
    //如果是查看消息 无法撤回重新编辑
    const setTime = imConfig.value?.messageRecallTime
    // 判断是否设置了无限制撤回
    const isUnlimitedRecall = setTime === 0
    if (!item.recallTimestamp) return true
    if (isUnlimitedRecall || moment().valueOf() - item.time <= setTime) return true
    return false
  }
  //获取患者私聊群信息
  const getPatientInfo = async (workOrderGroupInfo, needGetMsg = true) => {
    const { doctorInfo = {}, patientInfo = {} } = workOrderGroupInfo || {}
    const result = await talkToPat({
      ucPatientId: patientInfo.ucUserId,
      ucDoctorId: doctorInfo.ucUserId
    })
    startPatientChat(result, needGetMsg)
  }
  //发起患者私聊
  const startPatientChat = (data = {}, needGetMsg = true) => {
    const { groupId = '', doctorAssistantInfos, patientInfo } = data
    privateId.value = groupId
    activeKey.value = groupId
    // 设置私聊群成员
    store.commit('workOrder/SET_PRIVATE_MEMBERS', [...doctorAssistantInfos, patientInfo])
    if (!needGetMsg) return
    queryHistoryMessage(groupId, 1)
  }
  //获取医生私聊群信息
  const getDoctorInfo = async (curGroupInfo, needGetMsg = true) => {
    const { doctorInfo = {} } = curGroupInfo || {}
    const result = await talkToDoctor({
      ucDoctorId: doctorInfo.ucUserId
    })
    startDoctorChat(result, needGetMsg)
  }
  //发起医生私聊
  const startDoctorChat = (data = {}, needGetMsg = true) => {
    const { groupId, bdInfos, daInfos, doctorInfo } = data
    if (!messageMap[groupId]) {
      setDoctorChatTabs(groupId)
    }
    doctorDaGroupId.value = groupId
    activeKey.value = groupId
    store.commit('workOrder/SET_PRIVATE_MEMBERS', [...bdInfos, ...daInfos, doctorInfo])
    if (!needGetMsg) return
    queryHistoryMessage(groupId, 1)
  }
  //设置医生私聊tabs
  const setDoctorChatTabs = groupId => {
    // 检查是否已存在相同 groupId
    if (!chatInfoGroupTabs.value.some(tab => tab.groupId === groupId)) {
      chatInfoGroupTabs.value = [
        ...chatInfoGroupTabs.value,
        {
          title: '医生私聊',
          groupId: groupId
        }
      ]
      messageMap[groupId] = []
      // 初始化新消息提醒对象
      newMsgTipsMap[groupId] = {
        visible: false,
        num: 0,
        gapHeight: 0,
        showLoading: false,
        reloadNewMsg: false,
        loadText: '向上加载',
        pageSize: 10,
        page: 1
      }
    }
  }

  //新消息提醒，消息已读状态更新
  const upChatHandle = newValue => {
    if (newValue && newValue.length > 0) {
      const message = newValue[newValue.length - 1]
      const role = handleMsgRole(message.from)
      newMsgTipsMap[activeKey.value].num = 0
      if (
        newMsgTipsMap[activeKey.value].reloadNewMsg ||
        newMsgTipsMap[activeKey.value].gapHeight < 200 ||
        (role === 2 && message.status !== 'read')
      ) {
        newMsgTipsMap[activeKey.value].reloadNewMsg = false
        updateMsgStatus(message.mid)
      } else {
        newValue.forEach(it => {
          it.status === 'unread' && newMsgTipsMap[activeKey.value].num++
        })
      }
    }
  }
  //滚动到最新的一条消息
  const scrollBottom = () => {
    if (!messageboxRefs[activeKey.value]) return
    const scrollHeight = messageboxRefs[activeKey.value]?.scrollHeight
    messageboxRefs[activeKey.value].scrollTop = scrollHeight
  }
  //滚动到最新的一条消息
  const scrollTop = () => {
    if (!messageboxRefs[activeKey.value]) return
    messageboxRefs[activeKey.value].scrollTop = 0
  }
  //更新消息状态
  const updateMsgStatus = mid => {
    nextTick(() => {
      mid && scrollBottom(mid)
      setTimeout(() => {
        store.commit('updateMessageStatus', {
          action: 'oneUserReadMsgs',
          readUser: activeKey.value
        })
      }, 100)
    })
  }
  //获取工单信息和群组信息
  const getGroupInfoFn = async gid => {
    //如果当前会话群聊id和群成员变动回调群id相同，调用群成员信息接口
    if (gid !== activeKey.value) return
    getCurrentGroupInfo()
  }
  //消息撤回回调
  const receivedMessage = message => {
    if (message.mid === imageViewerRef.value?.currentMsgId) {
      Modal.warning({
        title: () => '该消息已被撤回',
        okText: () => '确定',
        onOk: () => {
          imageViewerVisible.value = false
        }
      })
    }
  }
  //新消息悬浮按钮点击
  const handleNewMsgTips = () => {
    const len = messageMap[activeKey.value]?.length || 0
    if (len) updateMsgStatus(messageMap[activeKey.value][len - 1].mid)
  }
  // 图片消息的时候判断能否撤回
  const handleImgRecall = item => {
    if (!item.bySelf) return false
    const setTime = imConfig.value?.messageRecallTime
    // 判断是否设置了无限制撤回
    const isUnlimitedRecall = setTime === 0
    return (
      isUnlimitedRecall ||
      (moment().valueOf() - item.time < setTime && imConfig.value?.messageRecallSwitch)
    )
  }
  //获取会话滚动区域高度
  const getScrollHeight = ({ target }) => {
    // 微信模块使用独立滚动状态，不进入原 IM 的 newMsgTipsMap 链路。
    const activeMsgTips = newMsgTipsMap[activeKey.value]
    if (!activeMsgTips) return
    const DOM = target
    const scrollHeight = DOM.scrollHeight, //滚动条的高度
      scrollTop = DOM.scrollTop, //滚动条在Y轴滚动过的高度
      clientHeight = DOM.clientHeight //浏览器的可视高度
    activeMsgTips.gapHeight = scrollHeight - scrollTop - clientHeight
    activeMsgTips.isScrollBottom = scrollTop + clientHeight === scrollHeight
    // 判断是否滚动到顶部
    activeMsgTips.isScrollTop = scrollTop === 0
    //100 之内都是消息已读
    if (activeMsgTips.gapHeight < 100) {
      activeMsgTips.visible = false
      updateMsgStatus()
    } else {
      activeMsgTips.visible = true
    }
  }
  //消息撤回
  const recalMessage = message => {
    activePopoverMessageId.value = ''
    const setTime = imConfig.value?.messageRecallTime
    // 判断是否设置了无限制撤回
    const isUnlimitedRecall = setTime === 0
    if (!isUnlimitedRecall && moment().valueOf() - message.time > setTime) {
      Modal.warning({
        title: () => '该消息超过撤回时间，不能被撤回',
        okText: () => '确定'
      })
      return
    }
    Modal.confirm({
      title: () => '确定撤回该条消息',
      icon: () => createVNode(ExclamationCircleOutlined),
      cancelText: () => '取消',
      okText: () => '确定',
      centered: true,
      onOk() {
        const { mid = '' } = message
        const params = { msgId: mid }
        messageRecall(params).then(result => {
          console.log('撤回消息', message)
          message.status = 'recall'
          message.msgStatus = -1
          store.commit('updateMessageStatus', message)
          EventBus.emit('receivedMessage', message)
        })
      }
    })
  }
  //撤回消息展示
  const renderRecal = (item, workOrderGroupInfo) => {
    if (item.bySelf) return '你撤回了一条消息'
    return (
      renderTitle(item.from) +
      '：' +
      renderName(item.from, { groupInfo: workOrderGroupInfo }) +
      '撤回了一条消息'
    )
  }
  //撤回消息展示
  const renderRecalByAI = item => {
    if (!item.operationUsers) return '系统撤回了一条消息'
    const Recals = item.operationUsers.find(v => v.operationType === 3)
    // 判断当前是不是自己撤回的记录
    const isMy = Recals.ucUserId === store.getters.userId && Recals.role === 4
    let text = ''
    if (isMy) {
      text = '你撤回了一条消息'
    } else {
      text = `${Recals.role === 3 ? 'BD' : '健管'}-${Recals.name}撤回了一条消息`
    }
    return text
  }
  //图片复制
  const copyImageMSG = msg => {
    copyImage(handleImg(msg))
    Message.success('复制成功')
  }
  //设置activeKey
  const setActiveTabsKey = id => {
    activeKey.value = id
  }
  // 获取透传消息处理策略
  const getCmdMessageStrategy = action => {
    const strategies = {
      // 问诊消息条数扣除/增加透传消息
      40015: msg => {
        getConsultDetail()
      }
    }
    return strategies[action]
  }
  const onCmdMessage = message => {
    console.log('收到CMD消息', message)
    const { action } = message
    // 获取对应的处理策略
    const strategy = getCmdMessageStrategy(action)
    if (strategy) {
      // 执行对应的处理策略
      strategy(message)
    } else {
      // 可以添加默认处理逻辑或日志记录
      console.log(`未知的透传消息类型: ${action}`)
    }
  }
  onMounted(() => {
    EventBus?.on('SET_ACTIVE_TABS_KEY', id => {
      setActiveTabsKey(id)
      nextTick(() => {
        scrollBottom()
      })
    })
    // 监听IM报错总线
    EventBus.on('onError', handleImError)
    EventBus.on('onOpened', () => (imErrorVisible.value = false))
    //监听当前群聊是否有新的成员加入
    EventBus.on('memberJoinPublicGroupSuccess', gid => getGroupInfoFn(gid))
    //监听撤回消息
    EventBus.on('receivedMessage', message => receivedMessage(message))
    //监听CMD 消息接收
    EventBus.on('cmdMessage', message => onCmdMessage(message))
  })
  onBeforeUnmount(() => {
    EventBus.off('SET_ACTIVE_TABS_KEY')
    EventBus.off('onError')
    EventBus.off('onOpened')
    EventBus.off('memberJoinPublicGroupSuccess')
    EventBus.off('receivedMessage')
    EventBus.off('cmdMessage')
  })
  return {
    tipsMessageType,
    defaultImage,
    activePopoverMessageId,
    isReadAckEnabled,
    imConfig,
    imErrorVisible,
    isSpinning,
    recallData,
    getMoreMsg,
    toTop,
    toBottom,
    scrollTop,
    reconnect,
    renderEdit,
    handleContextMenu,
    getPatientInfo,
    getDoctorInfo,
    startPatientChat,
    startDoctorChat,
    getTimeVisible,
    upChatHandle,
    updateMsgStatus,
    handleNewMsgTips,
    handleImgRecall,
    getScrollHeight,
    recalMessage,
    renderRecal,
    renderRecalByAI,
    copyImageMSG,
    scrollBottom,
    setActiveTabsKey
  }
}
